
$(function () {
    $(".widget-grid").each(function (idx, element) {
        var defaultPageSize = parseInt($(element).data("page-size"));
        var $errorElement = $(element).find(".widget-grid-error");
        var $spinnerElement = $(element).find(".widget-grid-spinner");
        var $tableLayout = $(element).find(".widget-grid-table");
        var $filtersElement = $(element).find("i[data-filter-listeners]");
        var $pagerElement = $(element).find(".widget-grid-pager");
        var $emptyLayout = $(element).find(".widget-grid-empty");
        var xhr = null;

        var url = $(element).data("url");
        var disablePaging = $(element).data("data-paging") == "true";
        var clickUrlFormat = $(element).data("click-url-format");
        var clickUrlParams = $(element).data("click-url-params");
        var urlParams = []; //array of {name: "", value: ""}
        var filterListeners = null;
        var fetching = false;
        var totalFetched = 0;
        var totalAvailable = 0;

        if (!disablePaging) {
            urlParams.push({ name: "skip", value: 0 });
        }

        if (clickUrlFormat && clickUrlParams) {
            //add a hover effect if the table rows are clickable
            $tableLayout.find("table").addClass("table-hover");
        }

        //error function
        var _showError = function (error) {
            fetching = false;
            totalFetched = 0;
            totalAvailable = 0;
            $errorElement.find("p").html(error || "Oops! Something went wrong");
            $errorElement.show();
            $spinnerElement.hide();
            $emptyLayout.hide();
            $tableLayout.hide();
            $pagerElement.hide();
        };

        /**
         * Wraps cells' inner content in an anchor element
         */
        var _applyClickableCell = function ($td, innerHtml, dataItem, onItemDataBoundFn) {
            var url = clickUrlFormat;
            var cellHtml = innerHtml;

            if (clickUrlFormat && clickUrlParams) {
                var params = clickUrlParams.toString().split(",");

                if (params && params.length > 0) {
                    for (var i = 0; i < params.length; i++) {
                        url = url.replace("{" + i.toString() + "}", dataItem[params[i]]);
                    }

                    cellHtml = "<a class='row-link' href='" + url + "'>"
                        + (innerHtml != undefined ? innerHtml : "") + "</a>";
                }
            }

            $td.html(cellHtml);

            if (onItemDataBoundFn) {
                var fn = window[onItemDataBoundFn];
                if (typeof fn === "function") {
                    fn($td, dataItem);
                }
            }
        };

        /**
         * Applies column templates to its cells
         */
        var _applyColTemplate = function ($row, dataItem, prop, template, className, onItemDataBoundFn) {
            var $td = $("<td></td>");

            if (className) {
                $td.addClass(className);
            }

            //TODO: Refactor!!! This refers to the GridColumnTemplateType enum in back-end
            if (template == "0") {
                _applyClickableCell($td, dataItem[prop], dataItem, onItemDataBoundFn);
            }
            else if (template == "1") {
                _applyClickableCell($td, "<span stems-date='" + dataItem[prop]
                    + "' stems-date-type='lg-date'></span>", dataItem, onItemDataBoundFn);
            }
            else if (template == "2") {
                var val = dataItem[prop] == "true" || dataItem[prop] == true ? "Yes" : "No";
                _applyClickableCell($td, val, dataItem, onItemDataBoundFn);
            }
            else if (template == "3") {
                _applyClickableCell($td, "<span stems-date='" + dataItem[prop]
                    + "' stems-date-type='date'></span>", dataItem, onItemDataBoundFn);
            }

            $row.append($td);
        };

        //success fetch function
        var _fetchSuccess = function (d, appending) {
            $pagerElement.hide();

            var pagingEnabled = (d.Items || d.items) && (d.totalItems || d.TotalItems);
            var items = d.Items || d.items || d;

            if (!items || !(items instanceof Array)) {
                fetching = false;
                return;
            }

            if (pagingEnabled && !disablePaging) {
                totalAvailable = d.totalItems || d.TotalItems;
                totalFetched += items.length;

                if ($tableLayout.children(".record-count").length > 0) {
                    var formattedCount = totalAvailable.format(0);
                    $tableLayout.children(".record-count").html(formattedCount + " record(s) found");
                }
            }
            else if (!disablePaging) {
                var formattedCount = items.length.format(0);
                $tableLayout.children(".record-count").html(formattedCount + " record(s) found");
            }

            var $ths = $tableLayout.find("th");
            var $tbody = $tableLayout.find("tbody");

            if (!appending) {
                $tbody.html(null);
            }

            for (var i = 0; i < items.length; i++) {
                var $tr = $("<tr></tr>");

                for (var j = 0; j < $ths.length; j++) {
                    var prop = $ths.eq(j).data("value");
                    var onItemDataBoundFn = $ths.eq(j).data("item-databound");
                    var template = $ths.eq(j).data("template");
                    var cssClass = $ths.eq(j)[0].className;

                    _applyColTemplate($tr, items[i], prop, template, cssClass, onItemDataBoundFn);
                }

                $tbody.append($tr);
            }

            if (items.length == 0) {
                $errorElement.hide();
                $spinnerElement.hide();
                $tableLayout.hide();
                $emptyLayout.show();
                fetching = false;
            }
            else {
                $errorElement.hide();
                $spinnerElement.hide();
                $tableLayout.show();
                $emptyLayout.hide();
                fetching = false;
            }
        };

        /**
         * Function that executes before every call to fetch
         */
        var _beforeFetch = function (appending) {

            var data = {};

            if (!appending) {

                setTimeout(function () {
                    if (fetching) {
                        $errorElement.hide();
                        $emptyLayout.hide();
                        $tableLayout.hide();
                        $spinnerElement.show();
                    }
                }, 500);

                totalAvailable = 0;
                totalFetched = 0;

                var found = $.grep(urlParams, function (item, idx) {
                    return item.name == "skip";
                });

                if (found.length > 0) {
                    found[0].value = 0;
                }
            }
            else {
                $pagerElement.show();
            }

            if (urlParams) {
                for (var i = 0; i < urlParams.length; i++) {
                    data[urlParams[i].name] = urlParams[i].value;
                }
            }

            if (xhr != null && xhr.readyState < 4) {
                xhr.abort();
            }


            fetching = true;
            return data;
        };

        //fetch function
        var _fetch = function (u, appending) {

            var data = _beforeFetch(appending);

            xhr = $.ajax({
                    url: u,
                    method: "GET",
                    data: data,
                    dataType: "json",
                    success: function (d) { _fetchSuccess(d, appending); },
                    error: function (x, s, e) {
                            //if aborting...
                            if (x.status === 0 && x.readyState === 0) return;
                            _showError("An error has ocurred. Please try again later");
                        }
                });
        };

        /**
         * Function that increases the skip value
         */
        var _increaseSkip = function () {
            var found = $.grep(urlParams, function (item, idx) {
                return item.name == "skip";
            });

            if (found.length > 0) {
                found[0].value += defaultPageSize; 
            }
        }

        if (!url) {
            _showError("The data attribute 'url' is required");
        }

        //hook filter listeners
        if ($filtersElement.length > 0) {
            filterListeners = JSON.parse($filtersElement.html());
            
            if (filterListeners && filterListeners.length > 0) {
                for (var i = 0; i < filterListeners.length; i++) {
                    var el = document.getElementById(filterListeners[i].id);

                    if (el != null) {
                        var param = filterListeners[i].param;

                        if (!param) {
                            param = $("#" + filterListeners[i].id).attr("name");
                        }

                        if (param) {
                            urlParams.push({ name: param, value: null });

                            $("#" + filterListeners[i].id).on(filterListeners[i].event, null, param
                                , function (e,d) {

                                    var _self = this;

                                    setTimeout(function () {
                                        //TODO: in some cases the value might come from the event
                                        var value = $(_self).val();

                                        if (!value && d) {
                                            value = d;
                                        }

                                        var found = $.grep(urlParams, function (item, idx) {
                                            return item.name == e.data;
                                        });

                                        if (!value) {
                                            //attempt to get values from a checkbox or radiobutton
                                            var ischecked = $(_self).is(":checked");

                                            if (ischecked) {
                                                value = ischecked;
                                            }
                                        }


                                        if (found && found.length > 0) {
                                            found[0].value = value;
                                        }

                                        _fetch(url);
                                    }, 50);
                                
                            });
                        }
                    }
                }
            }
        }

        //scroll listener
        if (!disablePaging) {
            $(document).scroll(function (e) {
                var h = $(element).offset().top + $(element).height();
                var scrollTop = $(window).height() + $(window).scrollTop();

                if (scrollTop >= h && !fetching && totalFetched < totalAvailable) {
                    _increaseSkip();
                    _fetch(url, true);
                }
            });
        }

        $.fn.rebind = function () {
            if (!this.hasClass("widget-grid")) {
                throw "rebind is undefined";
                return;
            }

            if (url) _fetch(url);
        };

        _fetch(url);
    });   
})
